export default {
  currentOpportunity: ({ currentEditedOpportunity }) => currentEditedOpportunity || {},
  languages: ({ languages }) => languages || [],
};
